import type { ReactNode } from 'react';
import { Route, Routes } from 'react-router-dom';
import { AuthGate } from './components/AuthGate';
import { Layout } from './components/Layout';
import { Card } from './components/ui';
import { useAuth } from './state/auth';
import { Library } from './pages/Library';
import { Add } from './pages/Add';
import { Search } from './pages/Search';
import { MovieDetail } from './pages/MovieDetail';
import { SeriesDetail } from './pages/SeriesDetail';
import { Activity } from './pages/Activity';
import { History } from './pages/History';
import { LibrarySync } from './pages/LibrarySync';
import { Settings } from './pages/Settings';
import { Users } from './pages/Users';

function AdminOnly({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  if (status?.role !== 'admin') {
    return <Card className="text-sm text-slate-400">Admins only — ask an administrator for access.</Card>;
  }
  return <>{children}</>;
}

export function App() {
  return (
    <AuthGate>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Library />} />
          <Route path="/add" element={<Add />} />
          <Route path="/search" element={<Search />} />
          <Route path="/movie/:id" element={<MovieDetail />} />
          <Route path="/series/:id" element={<SeriesDetail />} />
          <Route path="/activity" element={<Activity />} />
          <Route path="/history" element={<History />} />
          <Route path="/library-sync" element={<LibrarySync />} />
          <Route path="/users" element={<AdminOnly><Users /></AdminOnly>} />
          <Route path="/settings" element={<AdminOnly><Settings /></AdminOnly>} />
        </Route>
      </Routes>
    </AuthGate>
  );
}
